module.exports = __webpack_public_path__ + "static/media/ic-call.d9ba9aaf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-call.svg
// module id = 604
// module chunks = 14